<h1 mat-dialog-title>Einstellungen löschen?</h1>
<div mat-dialog-content>
	Möchten Sie die endooConnect Einstellungen für dieses Netzwerk wirklich löschen?
</div>
<mat-dialog-actions>
	<button mat-raised-button title="Abbrechen" id="delete-cancel-router-network-button"
		(click)="cancelDeleteNetworkClick_dialog()">Abbrechen</button>
	<button mat-raised-button title="Löschen" id="delete-confirm-router-network-button"
		(click)="deleteNetworkClick_dialog()">Löschen</button>
</mat-dialog-actions>